import clsx from "clsx";
import { format } from 'date-fns';
import React from 'react';
import styles from "./PhuHuynhCSKHItem.module.css";
const PhuHuynhDKItem = ({ ts_dangky, ts_form_items }) => {
    return (
        <div className={styles.container}>

            <div className={styles.header}>
                <div className={clsx(styles.trang_thai, ts_dangky.is_attendanced ? styles.da_xu_ly : "")}>
                    <span>
                        {ts_dangky.is_attendanced ? "Đã điểm danh" : "Chưa điểm danh"}
                    </span>
                </div>
                <div className={styles.noi_dung}>{"Chiến dịch: "+ts_dangky.ten_chien_dich}</div>
            </div>
            <div className={styles.khach_hang_info}>
                <div className={styles.info_container}>
                    <i className="fas fa-user"></i>
                    <b>{ts_dangky.ho_ten}</b>
                </div>
                <div className={styles.info_container}>
                    <i className="fas fa-phone"></i>
                    <b>{ts_dangky.phone_number}</b>
                </div>
                <div className={styles.info_container}>
                    <i className="fas fa-clock"></i>
                    <b>{format(new Date(ts_dangky.register_date), 'dd/MM/yyyy')}</b>
                </div>
            </div>
            {ts_form_items.map((x) => {
                  return (
                    <div className={styles.body}>
                        <b>{x.label}: </b>{ts_dangky[`T_${x.id}`]}
                    </div>
                  );
            })}

        </div>
    );
};

export default PhuHuynhDKItem;